<ng-sidebar-container>
	<ng-sidebar [(opened)]="opened" [sidebarClass]="'responsive-menu'">
		<div class="menu-header">
			<span>{{ 'appComponent.button.menu' | translate }}</span>
			<i class="cfe cfe-close float-right" (click)="closeSidebar()"></i>
		</div>
		<cfe-menu></cfe-menu>
	</ng-sidebar>

	<div class="sidebar-content" #scrollContent ng-sidebar-content>
		<div class="page-wrapper">
			<cfe-header></cfe-header>
			<cfe-breadcrumb *ngIf="internal"></cfe-breadcrumb>

			<div class="container-content" [ngClass]="{ 'container-fluid': internal }">
				<div [ngClass]="{ row: internal }">
					<div *ngIf="internal" class="sidebar col-md-4">
						<div class="sidebar-wrapper">
							<div #content>
								<cfe-menu></cfe-menu>
							</div>
						</div>
					</div>
					<div class="content" [ngClass]="{ 'col-md-8': internal }">
						<div class="menu-button" *ngIf="internal">
							<cfe-button
								[buttonStyle]="'btn-primary'"
								[iconName]="'forward-arrow'"
								[label]="'dashboardComponent.button' | translate"
								(click)="opened = true"
							></cfe-button>
						</div>
						<div class="spinner" [ngClass]="{ 'show-spinner': hideContent?.getValue() === 0 }" *ngIf="internal">
							<div #spinner class="justify-content-center d-flex">
								<img src="assets/images/progress-transparent.gif" alt="" height="42px" class="align-self-center" />
							</div>
						</div>
						<div *ngIf="externalLoader.getValue() === 0" class="spinner spinner-external">
							<div>
								<img src="assets/images/progress-transparent.gif" alt="" height="42px" class="align-self-center" />
								<div>{{ 'appComponent.text.automaticRedirectTitle' | translate }}</div>
								<div>{{ 'appComponent.text.automaticRedirectMessage' | translate }}</div>
							</div>
						</div>
						<router-outlet></router-outlet>
						<div class="module-loader">
							<cfe-loader></cfe-loader>
						</div>
					</div>
				</div>
			</div>

			<cfe-footer></cfe-footer>
		</div>
	</div>
</ng-sidebar-container>

<cookie-law #cookieLaw>
	<div class="container-fluid">
		<div class="cookie-wrapper">
			<div class="row">
				<div class="col-sm-10 mb-s cookie-text">
					<span [innerHTML]="cookieText"></span>
				</div>
				<div class="col-sm-2">
					<div class="d-flex align-items-center h-100">
						<cfe-button
							[buttonStyle]="'btn-primary mt-3 mt-sm-0'"
							[iconName]="'forward-arrow'"
							[label]="'appComponent.button.ok' | translate"
							(click)="dismissCookieBar()"
						></cfe-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</cookie-law>

<!--TimeOutModal will be shown after 20 Minutes // 1200 seconds-->
<div *ngIf="currentUser">
	<cfe-session-timeout
		[secondsRemaining]="config?.cfeSessionTimeout?.secondsRemaining"
		[sessionTimeOutInSeconds]="config?.cfeSessionTimeout?.sessionTimeOutInSeconds"
		(modalResult)="resultModal($event)"
	>
	</cfe-session-timeout>
</div>

<cfe-terms-and-conditions-modal></cfe-terms-and-conditions-modal>

<cfe-notify-or-confirm></cfe-notify-or-confirm>
